import { render, staticRenderFns } from "./VisistsComponent.vue?vue&type=template&id=93275af8&scoped=true"
import script from "./VisistsComponent.vue?vue&type=script&lang=js"
export * from "./VisistsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93275af8",
  null
  
)

export default component.exports